import Link from 'next/link'
import React from 'react'
import {
  AuthorName,
  BlogPostCardAuthor,
  BlogPostCardCategoryTitle,
  BlogPostCardContent,
  BlogPostCardImage,
  BlogPostCardTitle,
  BlogPostCardWrapper
} from './BlogPostCard.styles'

export const BlogPostCard = ({ post, huge, refFn }) => {
  return (
    <Link passHref href={`/blog/${post.slug}`}>
      <BlogPostCardWrapper
        onClick={() => {
          if (typeof document !== 'undefined') {
            document.querySelector('#scroll-box').scrollTo(0, 0)
          }
        }}
        ref={refFn}
        huge={huge}
      >
        {post?.cover_image?.data?.attributes?.url ? (
          <BlogPostCardImage
            huge={huge}
            alt=""
            src={post.cover_image.data.attributes.url}
          />
        ) : (
          <BlogPostCardImage as="div" placeholder huge={huge} />
        )}
        <BlogPostCardContent huge={huge}>
          {post?.categories?.data[0]?.attributes.title && (
            <BlogPostCardCategoryTitle>
              {post?.categories?.data[0]?.attributes?.title}
            </BlogPostCardCategoryTitle>
          )}
          <BlogPostCardTitle huge={huge}>{post.title}</BlogPostCardTitle>
          <BlogPostCardAuthor>
            By <AuthorName>{post?.author?.data?.attributes?.name}</AuthorName>
          </BlogPostCardAuthor>
        </BlogPostCardContent>
      </BlogPostCardWrapper>
    </Link>
  )
}
